document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        if ( document.querySelectorAll('.logoSlider').length ) {

            const elements = document.querySelectorAll('.logoSlider');

            elements.forEach(function(element) {
                let logoSlider = new Swiper(element.querySelector(".swiper"), {
                    preloadImages: false,
                    lazy: {
                        checkInView: true,
                        loadPrevNext: true,
                    },
                    watchOverflow: true,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 1,
                        disableOnInteraction: false
                    },
                    freeMode: true,
                    speed: 3000,
                    loop: true,
                    spaceBetween: 20,
                    //centerInsufficientSlides: true,
                    breakpoints: {
                        350: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        550: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        },
                        1100: {
                            slidesPerView: 5,
                            spaceBetween: 20
                        },
                        1450: {
                            slidesPerView: 6,
                            spaceBetween: 25
                        },
                        1700: {
                            slidesPerView: 6,
                            spaceBetween: 30
                        }
                    },
                    //navigation: {
                    //    nextEl: element.querySelector(".swiper-button-next"),
                    //    prevEl: element.querySelector(".swiper-button-prev"),
                    //}
                });
            });
            elements.forEach(function(element) {

                let timeline = gsap.timeline({defaults: {autoAlpha: 0, ease: "none"}});

                    timeline
                        .from(element.querySelectorAll('h2'), {x: -10, y: -20, ease:"power2.out", duration: .6})
                        .from(element.querySelectorAll('.swiperContainer'), {x: 10, y: 20, ease:"power2.out", duration: .3}, "<")
                    ;

                ScrollTrigger.create({
                    trigger: element,
                    animation: timeline,
                    start: "top 70%",
                    end: "bottom 70%",
                    toggleActions: "play none none none",
                    //markers: true
                });
            });
        }
    });
});
